
<div class="workflow-wrapper">
  <control-panel key="control-panel"></control-panel>
  <workarea key="workarea"></workarea>
  <config-panel key="config-panel"></config-panel>
</div>
